import { Title2, Text, Button } from '@fluentui/react-components';
import { useNavigate } from 'react-router';
import { useT } from '../i18n';

export function AccountInactivePage() {
  const navigate = useNavigate();
  const t = useT();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', gap: 16, padding: 24 }}>
      <Title2>{t.accountInactive.title}</Title2>
      <Text>{t.accountInactive.message}</Text>
      <Button appearance="primary" onClick={() => navigate('/login')}>{t.accountInactive.backBtn}</Button>
    </div>
  );
}
